import React from 'react';
import './DaySelect.css';
import DayButton from './DayButton/DayButton';
import icoDaySelect from '../../../../../assets/img/ico-day-select.png';
import icoLeft from '../../../../../assets/img/arrow-day-left.png';
import icoRight from '../../../../../assets/img/arrow-day-right.png';
import { MONTHS, WEEK_LENGTH } from '../../../../../constants';

// todo - is importing assets like 'icoDaySelect' good idea
// todo - maybe set icons as svg

function DaySelect(props) {
  const {
    monthId,
    daysData,
    onOpenList,
    prevActive,
    nextActive,
    onMonthSwapPrev,
    onMonthSwapNext,
    onDaySelect,
    daySelectOpen
  } = props;

  const weeksTotal = Math.ceil(daysData.length / WEEK_LENGTH);
  const weeks = [];
  for (let i = 0; i < weeksTotal; i += 1) {
    const startDayId = i * WEEK_LENGTH;
    const days = [];
    for (let d = 0; d < WEEK_LENGTH; d += 1) {
      const dayPosition = startDayId + d;
      if (dayPosition < daysData.length) {
        const dayData = daysData[dayPosition];
        days.push(
          <DayButton
            key={dayData.id}
            dayData={dayData}
            onDaySelect={onDaySelect}
          />
        );
      }
    }
    weeks.push(
      <div key={`${monthId}-${i}`} className="week-wrap">
        {days}
      </div>
    );
  }

  return (
    <div id="day-select">
      <button onClick={onOpenList}>
        <img src={icoDaySelect} alt="Vybrat den" />
      </button>
      <div className={`month-list ${daySelectOpen ? 'active' : ''}`}>
        <div className="title-month">{MONTHS[monthId]}</div>
        <button
          className={`btn-swap prev ${!prevActive ? 'inactive' : ''}`}
          onClick={onMonthSwapPrev}
        >
          <img src={icoLeft} alt="Předchozí" />
        </button>
        <button
          className={`btn-swap next ${!nextActive ? 'inactive' : ''}`}
          onClick={onMonthSwapNext}
        >
          <img src={icoRight} alt="Další" />
        </button>
        <div className="weeks-wrap">{weeks}</div>
      </div>
    </div>
  );
}

export default DaySelect;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/DaySelect/DaySelect.js